// extracted by mini-css-extract-plugin
export default {"pageEducaFiles":"Page_EducaFiles_pageEducaFiles__djrtZ","layout":"Page_EducaFiles_layout__2jK2-","sidebar":"Page_EducaFiles_sidebar__t9d4K","main":"Page_EducaFiles_main__BasHQ"};